import React from "react";
import { useNavigate } from "react-router-dom";
import IndusIndLogo from "../../assets/BankLogo/indusland.png";
import AxisLogo from "../../assets/BankLogo/axis.png";
import HDFCLogo from "../../assets/BankLogo/hdfc.png";
import KotakLogo from "../../assets/BankLogo/kotak.png";


const BusinessLoanBankOffer = () => {
    const navigate = useNavigate();
  const plans = [
    {
      loanType: "business",
      title: "Business Loan",
    },
  ];
  
  const loanData = [
    {
      loanType: "Business Loan",
      bank: "Kotak Bank",
      loanAmount: "₹25L - ₹1 Cr",
      interestRate: "15% - 17% p.a",
      tenure: "2/3/4 Years",
      tag: "Real Time Offer",
      bankLogo: KotakLogo
    },
    {
      loanType: "Business Loan",
      bank: "HDFC Bank",
      loanAmount: "₹25L - ₹75L",
      interestRate: "15% - 17% p.a",
      tenure: "2/3/4 Years",
      tag: "Real Time Offer",
      bankLogo: HDFCLogo
    },
    {
      loanType: "Business Loan",
      bank: "IndusInd Bank",
      loanAmount: "₹25L - ₹75L",
      interestRate: "15% - 17% p.a",
      tenure: "2/3/4 Years",
      tag: "Real Time Offer",
      bankLogo: IndusIndLogo
    },
    {
      loanType: "Business Loan",
      bank: "Axis Bank",
      loanAmount: "₹25L - ₹75L",
      interestRate: "15% - 17% p.a",
      tenure: "2/3/4 Years",
      tag: "Real Time Offer",
      bankLogo: AxisLogo
    },
  ];

  const handleApplyClick = (loanType) => {
    navigate("/otp-verification", { state: { loanType } });
  };

  return (
    <div className="pricing-main-container">
      <h4 className="bank-offer-title">{loanData[0].loanType}</h4>
      <p className="bank-offer-description">
        “Self-employed individuals with an annual turnover of ₹1 crore or more
        can apply here.
        <br />
        <span className="highlight-rate">
          GST registration with 3 Year vintage and owning a house are
          mandatory.
        </span>”
      </p>
      <div className="pricing-cards">
        {loanData.map((loan, index) => (
          <div key={index} className="pricing-card">
            <div className="bank-header">
              <img src={loan.bankLogo} alt={loan.bank} className="bank-logo" />
              <h3 className="bank-name">{loan.bank}</h3>
            </div>
            <p>
              <strong>Loan Amount:</strong> {loan.loanAmount}
            </p>
            <p>
              <strong>Interest Rate:</strong> {loan.interestRate}
            </p>
            <p>
              <strong>Tenure:</strong> {loan.tenure}
            </p>
            <p className="offer-tag">{loan.tag}</p>
            {plans.map((plan, index) => (
              <button
                className="apply-button"
                key={index}
                onClick={() => handleApplyClick(plan.loanType)}
              >
                Check Eligibility
              </button>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
export default BusinessLoanBankOffer;
